import React, { useEffect, useState } from 'react'

import { stripeAPI } from '../../api/services/stripe'
import { StripeBalanceObject } from '../../api/services/stripe/types.ts'
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs.tsx'
import Card from '../../components/common/Card/Card.tsx'
import Loader from '../../components/common/Loader/Loader.tsx'
import BalanceItem from '../../components/payments/BalanceItem.tsx'

const Balance = () => {
  const [refetch, setRefetch] = useState(0)
  const [data, setData] = useState<StripeBalanceObject | null>(null)
  const [loader, setLoader] = useState(false)

  useEffect(() => {
    const fetchBalance = async () => {
      try {
        setLoader(true)
        const data = await stripeAPI.retrieve_stripe_balance()
        setData(data)
      } catch (error) {
        console.error('Error fetching balance:', error)
      } finally {
        setLoader(false)
      }
    }
    fetchBalance()
  }, [refetch])

  return (
    <>
      <Breadcrumbs pageName="Saldo" breadcrumbs={[]} />

      <Card>
        <Card.Title>Podsumowanie konta Stripe</Card.Title>
        <Card.Body>
          {loader && <Loader label={'Pobieranie danych o saldzie...'} />}
          {data && (
            <>
              <BalanceItem
                label={'Środki dostępne do wypłaty:'}
                data={data}
                type={'available'}
                setRefetch={setRefetch}
              />

              <BalanceItem
                label={'Środki będące w trakcie sprawdzania:'}
                data={data}
                type={'pending'}
                setRefetch={setRefetch}
              />
            </>
          )}
        </Card.Body>
      </Card>
    </>
  )
}

export default Balance
